export class LottolocaDebugger {
    public static log(cod: number, message: any, ...filters: string[]): void {

        //   let filters = filter.toLocaleLowerCase().split(' ');

        if (cod < 0 ) {
            console.log(message);
            return;
        }
        if (cod == 120) {

            if (filters.length > 0) {
                let filter = filters[0];
                let parameters = filters.slice(1);

                if( parameters.every(x => filter.toLowerCase().indexOf(x.toLowerCase()) >= 0) )
                {
                    console.log(message);
                }
//&& filters.some(x => message.toLowerCase().indexOf(x) >= 0)
            }
            else {
                console.log(message);
            }
        }
    }
}